import {
  Box, Grid, Typography, Link as MuiLink, Divider, Stack, IconButton, Container,
  // Tooltip
} from "@mui/material";
import { ReactComponent as FacebookIcon } from "../assets/icons/facebook.svg";
import { ReactComponent as LinkedInIcon } from "../assets/icons/linkedin.svg";
import { ReactComponent as YouTubeIcon } from "../assets/icons/youtube.svg";
import { useTranslator } from "../context/TranslatorContext";
import { Link } from 'react-router-dom';

export default function Footer() {
  const {messages} = useTranslator();

  return (
    <Box component="footer" sx={{ pb: 8, backgroundColor: "#00002e", color: "#fff", pt: 4, px: { xs: 2, md: 6 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Left Column: Title and Socials */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              {messages.lds_title}
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton
                component="a"
                href="https://linkedin.com/company/langdataspace"
                target="_blank"
                rel="noopener"
                sx={{ color: "#fff" }}              >
                <LinkedInIcon/>
              </IconButton>
              <IconButton
                component="a"
                href="https://facebook.com/langdataspace"
                target="_blank"
                rel="noopener"
                sx={{ color: "#fff" }}
              >
                <FacebookIcon/>
              </IconButton>
              <IconButton
                component="a"
                href="https://youtube.com/@langdataspace"
                target="_blank"
                rel="noopener"
                sx={{ color: "#fff" }}
              >
                <YouTubeIcon className="wt-icon"/>
              </IconButton>
            </Stack>
          </Grid>

          {/* Middle Column: Contact */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
              {messages.footerContactLinkTitle}
            </Typography>
            <MuiLink
              href="https://language-data-space.ec.europa.eu/about_en" // replace with the actual URL
              underline="hover"
              color="inherit"
              target="_blank" rel="noopener noreferrer"
              variant="body2"
            >
              <Typography variant="h6">{messages.footerContactLinkText}</Typography>
            </MuiLink>
          </Grid>

          {/* Right Column: About */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
              {messages.footerLearnMoreLinkTitle}
            </Typography>
            <MuiLink
              href="https://language-data-space.ec.europa.eu/about_en" // replace with the actual URL
              underline="hover"
              color="inherit"
              target="_blank" rel="noopener noreferrer"
              variant="body2"
            >
              <Typography variant="h6">{messages.footerLearnMoreLinkText}</Typography>
            </MuiLink>
          </Grid>
        </Grid>

        {/* Light Blue Divider */}
        <Divider sx={{ borderColor: "#ACC3EA", my: 3, borderWidth: "1px" }} />

        {/* Bottom Row */}
        <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
          <MuiLink href="https://language-data-space.ec.europa.eu/data-processing-agreement" target="_blank" rel="noopener noreferrer" underline="hover" color="inherit">
            <Typography variant="h6">{messages.privacyPolicyLinkText}</Typography>
          </MuiLink>
          <Typography>|</Typography>
          <MuiLink href="https://language-data-space.ec.europa.eu/general-terms-and-conditions-testing-language-data-space" target="_blank" rel="noopener noreferrer" underline="hover" color="inherit">
            <Typography variant="h6">{messages.LegalNoticeLinkText}</Typography>
          </MuiLink>
          <Typography>|</Typography>
          <MuiLink component={Link} to="/cookie-policy" underline="hover" color="inherit">
            <Typography variant="h6">{messages.cookiePolicyLinkText}</Typography>
          </MuiLink>
          {/* <Typography>|</Typography>
          <Tooltip title={messages.matomoWithdrawConcentTooltip}>
            <IconButton aria-label="Withdraw-Consent" size="small" onClick={handleWithdrawConsent} sx={{ padding: 0 }}>
              <SettingsOutlinedIcon fontSize="small" sx={{ color: "#fff"}} />
            </IconButton>
          </Tooltip>*/}
        </Box>
      </Container>
    </Box>
  );
}
